import { Typography } from "@mui/material";
import React from "react";

function NavButtons({ isMobileFlag, menuItems }) {
  return (
    <>
      {" "}
      <nav className={isMobileFlag ? "nav-buttons-mobile" : "nav-buttons"}>
        {menuItems.map((menuItem, ind) => {
          return (
            <Typography
              key={ind}
              onClick={menuItem.click}
              color="#3D3D3D"
              className="nav-btn"
              sx={{
                fontFamily: "Poppins-Medium",
                fontSize: "medium",
                cursor: "pointer",
              }}
            >
              {menuItem.lable}
            </Typography>
          );
        })}
      </nav>
    </>
  );
}

export default NavButtons;
